import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["as", "children", "appearance", "size", "styles", "className", "style", "action"];
import React, { forwardRef } from 'react';
import cx from 'classnames';
import Box from '../Box';
export var SYSTEM_PROPS = ['flexProps', 'marginProps', 'floatProps'];
var Base = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _classNames;

  var as = _ref.as,
      children = _ref.children,
      appearance = _ref.appearance,
      size = _ref.size,
      styles = _ref.styles,
      className = _ref.className,
      style = _ref.style,
      action = _ref.action,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var classNames = (_classNames = {}, _classNames[styles.root] = true, _classNames[styles.primary] = appearance === 'primary', _classNames[styles.secondary] = appearance === 'secondary', _classNames[styles.small] = size === 'small', _classNames[styles.large] = size === 'large', _classNames);
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    className: cx(classNames, className),
    style: style,
    as: as,
    width: "full",
    position: "relative"
  }, rest), /*#__PURE__*/React.createElement("span", {
    className: styles.inner
  }, children), action && /*#__PURE__*/React.createElement("span", {
    className: styles.action
  }, action));
});
Base.defaultProps = {
  appearance: 'primary',
  as: 'h1',
  size: 'large'
};
export default Base;